module.exports = __webpack_public_path__ + "img/ascend_gold17.b37461ad.png";